export default __webpack_public_path__ + "static/media/Icon material-email.0314fd66.svg";